module.exports = __webpack_public_path__ + "view/img/person.b9e2e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person.png
// module id = Xi0g
// module chunks = 1